import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import {
  setCompany,
  setCompanyActionStart,
  setCompanyErrorMessage,
} from "../../constants/reducers/company.reducer";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { AxiosResponse } from "axios";
import { GetOneCompanyDTO } from "../../constants/dto/company";

type GetCompanyProp = {
  id: number;
};

let body: GetOneCompanyDTO;

export const getOneCompany = async ({ id }: GetCompanyProp) => {
  store.dispatch(setCompanyActionStart(true));

  const queryParams = new URLSearchParams();

  if (id) queryParams.append("id", id.toString());

  const request = await createCall(
    "cms/companies/get-one",
    BASE_METHODS.GET,
    "application/json",
    "1.0.0",
    undefined,
    queryParams
  );

  try {
    const response = request as AxiosResponse;
    body = plainToClass(GetOneCompanyDTO, response.data);
    const errors = await validate(body);
    if (errors.length > 0) {
      store.dispatch(
        setCompanyErrorMessage(TextEnum.GET_ONE_COMPANY_INVALID_RESPONSE)
      );
      return null;
    }
    store.dispatch(setCompany({ company: response.data.company }));
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponeData: CustomErrorType = responseError.response?.data;
    if (errorResponeData) {
      let errorMessage = "";
      switch (errorResponeData.code) {
        case 2001:
          errorMessage = TextEnum.GET_ONE_COMPANY_COMPANY_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setCompanyErrorMessage(errorMessage));
      return null;
    }
    store.dispatch(setCompanyActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
